import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.129 4.278v8h1.5v-8h-1.5Zm8.5 7.75v-7.75h-1.5v7.75h1.5Zm-3.5 0v-8.75h-1.5v8.75h1.5Zm-5 .25c0 1.317.49 2.187 1.032 2.726.263.262.528.435.731.544a2.67 2.67 0 0 0 .368.163c.004 0 .008.002.01.003l.005.002h.003L5.5 15a59.412 59.412 0 0 1 .223-.716h.001a1.669 1.669 0 0 1-.506-.344c-.268-.266-.59-.757-.59-1.662h-1.5Zm6 .75a1 1 0 0 1-1-1h-1.5a2.5 2.5 0 0 0 2.5 2.5v-1.5Zm2.5-8.75a4.25 4.25 0 0 0-4.25-4.25v1.5a2.75 2.75 0 0 1 2.75 2.75h1.5Zm-1.5 7.75a1 1 0 0 1-1 1v1.5a2.5 2.5 0 0 0 2.5-2.5h-1.5Zm-5.5-7.75a2.75 2.75 0 0 1 2.75-2.75v-1.5a4.25 4.25 0 0 0-4.25 4.25h1.5Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgPaperClip = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgPaperClip;
